/**
 * Constants for batch operations
 * @module batch-constants
 */

/**
 * Default gas price for batch operations
 */
export const DEFAULT_GAS_PRICE = '0.025uakt'

/**
 * Default gas adjustment multiplier for estimating gas needs
 */
export const DEFAULT_GAS_ADJUSTMENT = 1.5

/**
 * Estimated gas per operation in batch transactions
 */
export const DEFAULT_GAS_PER_OPERATION = 50000

/**
 * Default deposit amount for deployment creation (in uakt)
 */
export const DEFAULT_DEPLOYMENT_DEPOSIT = '5000000'

/**
 * Default denomination for Akash Network tokens
 */
export const DEFAULT_DENOM = 'uakt'

/**
 * Default group sequence for lease creation
 */
export const DEFAULT_GSEQ = 1

/**
 * Default order sequence for lease creation
 */
export const DEFAULT_OSEQ = 1

/**
 * Mock public key placeholder for certificate creation
 */
export const MOCK_PUBKEY = 'mock-pubkey'
